import { useCallback } from "react";
import { useStore } from "@xyflow/react";

/**
 * Subscribe to only the measured.width of a node
 * This prevents unnecessary re-renders when other node properties change
 */
export function useNodeMeasuredWidth(nodeId: string): number | undefined {
  return useStore(
    useCallback(
      (state) => state.nodeLookup.get(nodeId)?.measured?.width,
      [nodeId],
    ),
  );
}
